import { ref } from 'vue'

const showMenu = ref(0)

export function composables() {
  return { showMenu }
}
